customElements.define(
    "marqy-el",
    class extends HTMLElement {
        connectedCallback() {
            const children = this.innerHTML;

            this.innerHTML = `
                <div class="marqy">
                    <div class="marqy-inner">
                        <div class="marqy-content">
                            <div class="marqy-item">
                                ${children}
                            </div>
                        </div>
                    </div>
                </div>`;

            this.marqy = this.querySelector(".marqy");
            this.inner = this.querySelector(".marqy-inner");
            this.content = this.querySelector(".marqy-content");
            this.item = this.querySelector(".marqy-item");

            this.speed = +this.getAttribute("speed") ?? 1;

            this.prevCloneCount = 0;
            this.cloneCount = 0;

            let contentClone = this.content.cloneNode(true);
            contentClone.setAttribute("aria-hidden", "true");
            this.inner.append(contentClone);

            window.addEventListener("resize", this.resize);
            this.resize();
        }

        disconnectedCallback() {
            window.removeEventListener("resize", this.resize);
        }

        resize = () => {
            let w = this.item.getBoundingClientRect().width;
            this.cloneCount = Math.ceil(this.marqy.getBoundingClientRect().width / w);
            if (this.cloneCount !== this.prevCloneCount) {
                for (let i = 0, l = this.inner.children.length; i < l; i++) {
                    const wrap = this.inner.children[i];
                    while (wrap.children.length > 1) {
                        wrap.children[wrap.children.length - 1].remove();
                    }

                    for (let i = 0; i < this.cloneCount; i++) {
                        let clone = this.item.cloneNode(true);
                        clone.setAttribute("aria-hidden", "true");
                        wrap.append(clone);
                    }
                }
            }
            this.inner.style.animationDuration = `${(Math.round(w) * this.cloneCount) / (100 * this.speed)}s`;
            this.prevCloneCount = this.cloneCount;
        };
    }
);
